import { z } from "zod";

import { ButterflowWorkflowSchema } from "./workflow-butterflow";

export const TriggerSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("manual"),
    description: z.string().optional(),
  }),
  z.object({
    type: z.literal("automatic"),
  }),
]);

const baseStepSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().optional(),
  type: z.enum(["manual", "automatic"]),
  dependsOn: z.array(z.string()).optional(),
  matrix: z
    .object({
      fromState: z.string(),
    })
    .optional(),
  trigger: TriggerSchema.optional(),
});

// Workflow V1
export const WorkflowSchema_v1 = z.object({
  version: z.literal("1"),
  steps: z.array(baseStepSchema),
});

// Workflow Butterflow
export const WorkflowButterflowSchema = z.object({
  version: z.literal("butterflow"),
  workflow: ButterflowWorkflowSchema,
});

export type WorkflowSchema_v1Type = z.infer<typeof WorkflowSchema_v1>;

export const WorkflowSchema = z.union([
  WorkflowSchema_v1,
  WorkflowButterflowSchema,
]);

export type WorkflowSchemaType = z.infer<typeof WorkflowSchema>;
export type TriggerSchemaType = z.infer<typeof TriggerSchema>;
